export default {
    fr:{
        //Expert / AO / Candidatures 16
        'Référence de l\'AO' :'Référence de l\'AO',
        'Réf.AO' :'Réf.AO',
        'Réf. AO':'Réf. AO',
        'Date de candidature' :'Date de candidature',
        'Date de candid.' :'Date de candid.',
        'Intitulé de l\'AO' :'Intitulé de l\'AO',
        'Statut candidature' :'Statut candidature',
        'Date de début souhaité' :'Date de début souhaité',
        'Date début souhaité' :'Date début souhaité',
        // 'Date de publication' :'Date de publication',
        // 'Durée de la mission' :'Durée de la mission',
        'Durée du BDC' :'Durée du BDC',
        'Budget' :'Budget',
        'TJ souhaité' :'TJ souhaité',
        'Ville et pays' :'Ville et pays',
        'Réf.Ordre de mission':'Réf.Ordre de mission',
        'Statut document':'Statut document',
        'Date début BDC':'Date début BDC',
        'Date fin BDC':'Date fin BDC',
        'Durée BDC':'Durée BDC',
        'TJ HT':'TJ HT',
        'Réf.mission' :'Réf.mission',
        'Réf. Mission' :'Réf. Mission',
        'Date d\'émission' :'Date d\'émission',
        'Intitulé de la mission' :'Intitulé de la mission',
        'Client' :'Client',
        'Statut' :'Statut',
        'Début souhaité' :'Début souhaité',
        // 'Durée de la mission' :'Durée de la mission',
        // 'Durée du BDC' :'Durée du BDC',
        'Responsable Opérationnel' :'Responsable Opérationnel',
        'Commercial' :'Commercial',
        'Ordre de mission à valider' :'Ordre de mission à valider',
        // 'Contexte de la mission' :'Contexte de la mission',
        'Télécharger l\'ordre de mission' :'Télécharger l\'ordre de mission',
        // 'Valider' :'Valider',
        'Ordre de mission' :'Ordre de mission',
        'Numéro de l\'ordre de mission' : 'Numéro de l\'ordre de mission',
        // 'Date de début souhaitée' : 'Date de début souhaitée',
        'Nombre de postes' :'Nombre de postes',

        //Expert / Missions et BDC/ BDC 21
        // 'Missions et BDC':'Missions et BDC',
        // 'Réf.mission' :'Réf.mission',
        'Réf.BDC' :'Réf.BDC',
        // 'Date d\'émission' :'Date d\'émission',
        'Type' :'Type',
        // 'Intitulé de la mission' :'Intitulé de la mission',
        'Statut mission' :'Statut mission',
        // 'Client' :'Client',
        'Date de début BDC' :'Date de début BDC',
        'Date début mission':'Date début mission',
        'Date fin mission':'Date fin mission',
        // 'Date début BDC':'Date début BDC',
        // 'Date fin BDC':'Date fin BDC',
        'Nb de jours':'Nb de jours',
        'Nb jours validés':'Nb jours validés',
        'TJ TTC':'TJ TTC',
        'Fréq.de renouvellement':'Fréq.de renouvellement',
        'Motif d\'interruption':'Motif d\'interruption',
        'Date de fin BDC' :'Date de fin BDC',
        // 'Durée du BDC' :'Durée du BDC',
        'Nombre de jours' :'Nombre de jours',
        'Date estimée de fin de mission' :'Date estimée de fin de mission',
        'Taux journalier' :'Taux journalier',
        'Responsable opérationnel' :'Responsable opérationnel',
        // 'Commercial' :'Commercial',
        // 'Motif d\'interruption' :'Motif d\'interruption',
        'Télécharger le bon de commande' :'Télécharger le bon de commande',
        //Expert / CRA et Factures / Liste des CRA 22
        'N°CRA' :'N°CRA',
        'Réf.Client':'Réf.Client',
        'Nom du client' :'Nom du client',
        // 'Intitulé de la mission' :'Intitulé de la mission',
        'Statut du CRA' :'Statut du CRA',
        'En attente de validation' :'En attente de validation',
        'Validé par l\'expert' :'Validé par l\'expert',
        'Validé par le Resp.Op' :'Validé par le Resp.Op',
        'Date validation/Expert' :'Date validation/Expert',
        'Date validation/Client' :'Date validation/Client',
        'Mois' :'Mois',
        // 'Année' :'Année',
        // 'Nb de jours' :'Nb de jours',
        'Taux journalier HT' :'Taux journalier HT',
        'Total Astreintes' :'Total Astreintes',
        'Total notes de frais':'Total notes de frais',

        //Expert / CRA et Factures / CRA 23
        // 'Compte rendu d\'activité' :'Compte rendu d\'activité',
        // 'Validé' :'Validé',
        // 'Non validé':'Non validé',
        'Jours facturés ce mois' :'Jours facturés ce mois',
        'Régularisation' :'Régularisation',
        'Astreintes' :'Astreintes',
        'Votre CRA a été validé avec succès!' :'Votre CRA a été validé avec succès!',
        'Avez-vous des astreintes, des HNO ou des notes de frais à ajouter?' :'Avez-vous des astreintes, des HNO ou des notes de frais à ajouter?',
        'Oui' :'Oui',
        'Non' :'Non',
        'Prestation Complémentaire' :'Prestation Complémentaire',
        'Type d\'astreinte' :'Type d\'astreinte',
        'Nombre d\'astreintes' :'Nombre d\'astreintes',
        'Montant' :'Montant',
        'HNO' :'HNO',
        'Type du HNO' :'Type du HNO',
        'Nombre d\'heures' :'Nombre d\'heures',
        'Montant total de la prestation complémentaire' :'Montant total de la prestation complémentaire',
        'Montant total' :'Montant total',
        'Ajouter des détails' :'Ajouter des détails',
        'Ajoutez des détails si nécessaire de détailler au client la nature et la date de chaque prestation complémentaire, et aussi ajoutez des pièces justificatives si vous en avez' :'Ajoutez des détails si nécessaire de détailler au client la nature et la date de chaque prestation complémentaire, et aussi ajoutez des pièces justificatives si vous en avez',
        'Ajouter un document' :'Ajouter un document',
        'Informations mission' :'Informations mission',
        'Réf. client' :'Réf. client',
        'Réf. Client' :'Réf. Client',
        // 'Nom du client' :'Nom du client',
        'Source' :'Source',
        'Réf. AO ou CVthèque' :'Réf. AO ou CVthèque',
        // 'Intitulé de la mission' :'Intitulé de la mission',
        'Nom de l\'expert' :'Nom de l\'expert',
        'Réf. Expert' :'Réf. Expert',
        'Date de début/mission' :'Date de début/mission',
        'Date de fin/mission': 'Date de fin/mission',
        // 'Nombre de jours' :'Nombre de jours',
        'Lieu de la mission' :'Lieu de la mission',
        'Personnel en charge de la mission' :'Personnel en charge de la mission',
        'Chargé de recrutement' :'Chargé de recrutement',
        'Responsable achat' :'Responsable achat',
        // 'Responsable opérationnel' :'Responsable opérationnel',
        'Responsable de comptabilité' :'Responsable de comptabilité',
        //Expert / CRA et Factures / Factures 24
        'Régularisations' :'Régularisations',
        // 'Factures' :'Factures',
        'Réf.Facture' :'Réf.Facture',
        // 'Date d\'émission' :'Date d\'émission',
        // 'Nom du client' :'Nom du client',
        // 'N°CRA' :'N°CRA',
        // 'Intitulé de la mission':'Intitulé de la mission',
        'Statut Paiement' :'Statut Paiement',
        'Non payé': 'Non payé',
        'Payé' :'Payé',
        'Période'	 :'Période',
        'Date d\'échéance'	:'Date d\'échéance',
        'Total HT' :'Total HT',
        'Total PC.HT' :'Total PC.HT',
        'TVA appliquée' :'TVA appliquée',
        'Total TTC' :'Total TTC',
        'Resp.Opérationnel' :'Resp.Opérationnel',
        //tableau Gestion des experts 49

        'Réf.expert':'Réf.expert',
        'CV HTH':'CV HTH',
        'CV d\'origine':'CV d\'origine',
        // 'Titre':'Titre',
        'Intitulé du CV':'Intitulé du CV',
        'Tél':'Tél',
        'E-mail':'E-mail',
        'Total Exp.':'Total Exp.',
        'Statut doc.administratifs':'Statut doc.administratifs',
        // 'Validé':'Validé',
        // 'A valider':'A valider',
        // 'Statut mission':'Statut mission',
        'Nb de missions':'Nb de missions',
        'En cours':'En cours',
        'A venir':'A venir',
        'Interrompue':'Interrompue',
        'Terminée':'Terminée',
        // 'Date de disponibilité':'Date de disponibilité',
        // 'Taux journalier':'Taux journalier',
        // 'Ville':'Ville',
        // 'Pays':'Pays',
        'Dernière activité':'Dernière activité',
        'Evaluation interne':'Evaluation interne',
        'Bloquer l\'utilisateur':'Bloquer l\'utilisateur',

        // 'Données profil':'Données profil',
        // 'Données CV':'Données CV',
        // 'Préférences':'Préférences',
        // 'Taux de la TVA':'Taux de la TVA',
        // 'Coordonnées bancaires':'Coordonnées bancaires',
        'RIB':'RIB',
        // 'IBAN':'IBAN',
        // 'BIC/SWIFT':'BIC/SWIFT',

        //interface_50_Gestion des clients
        // 'Réf.Client':'Réf.Client',
        'Statut du compte':'Statut du compte',
        'Activé':'Activé',
        'Non activé':'Non activé',
        'Statut doc.administratif':'Statut doc.administratif',
        'AO ouverts':'AO ouverts',
        // 'Nb de missions':'Nb de missions',
        'TVA appliqué':'TVA appliqué',

        'Profil entreprise':'Profil entreprise',
        // 'Données Générales':'Données Générales',
        'Collaborateurs entreprise':'Collaborateurs entreprise',
        // 'Données Facturation':'Données Facturation',
        // 'Prestation Complémentaire':'Prestation Complémentaire',
        // 'Conditions de paiement':'Conditions de paiement',
        'Par virement':'Par virement',
        'Type de règlement':'Type de règlement',
        'Délai de paiement':'Délai de paiement',
        // 'Astreintes':'Astreintes',
        // 'Type d\'astreinte':'Type d\'astreinte',
        'Astreinte standard':'Astreinte standard',
        // 'Montant':'Montant',
        // 'HNO':'HNO',
        'Type de HNO':'Type de HNO',

        //Gestion des candidatures 53
        //CVthèque
        // 'Appels d\'offres':'Appels d\'offres',
        'CVthèque':'CVthèque',
        'Ao':'Ao',
        // 'Gestion des RDV':'Gestion des RDV',

        // 'Réf.AO':'Réf.AO',
        'Réf.AO Client':'Réf.AO Client',
        // 'Réf.Client':'Réf.Client',
        'Nom du Client':'Nom du Client',
        'Intitulé AO':'Intitulé AO',
        'Statut AO':'Statut AO',
        // 'Nb de recrutement':'Nb de recrutement',
        // 'Date de publication':'Date de publication',
        // 'Nb de candidatures':'Nb de candidatures',
        'Candidatures «à interviewer»':'Candidatures «à interviewer»',
        'Candidatures «Retenues»':'Candidatures «Retenues»',
        'Date Début souhaitée':'Date Début souhaitée',
        'Date Fin estimée':'Date Fin estimée',
        // 'Localisation':'Localisation',
        // 'Durée du BDC':'Durée du BDC',
        // 'Nb de jours':'Nb de jours',
        // 'Budget':'Budget',
        'Créé par':'Créé par',
        // 'Resp.Opérationnel':'Resp.Opérationnel',
        'Resp.Achat':'Resp.Achat',
        'Date Fin publication':'Date Fin publication',
        // 'En cours':'En cours',
        'Draft':'Draft',
        'Clôturé':'Clôturé',
        'Non publié':'Non publié',
        'Statut Candidature':'Statut Candidature',
        // 'Non lue':'Non lue',
        // 'Lue':'Lue',
        // 'Intéressante':'Intéressante',
        // 'A interviewer':'A interviewer',
        // 'Non retenue':'Non retenue',
        // 'Retenue':'Retenue',

        'Réf.Besoin':'Réf.Besoin',
        'Intitulé du besoin':'Intitulé du besoin',
        'Statut besoin': 'Statut besoin',

        //gestion des rdv_52
        'Emplacement':'Emplacement',
        'Heure de début':'Heure de début',
        'Heure de fin':'Heure de fin',
        'Note':'Note',
        'Rejeter':'Rejeter',
        'Replanifier':'Replanifier',
        'Accepter':'Accepter',

        //Créer une mission_51

        'Créer une mission':'Créer une mission',
        'Renouveler un BDC':'Renouveler un BDC',
        'Modifier un BDC':'Modifier un BDC',

        'Informations BDC':'Informations BDC',
        'Date de début/BDC':'Date de début/BDC',
        'Date de fin/BDC':'Date de fin/BDC',
        // 'Nombre de jours':'Nombre de jours',
        'Fréquence de renouv.':'Fréquence de renouv.',
        'Taux journalier/expert':'Taux journalier/expert',
        'Taux journalier/client':'Taux journalier/client',
        'Taux de commission':'Taux de commission',
        'N°commande client':'N°commande client',
        'Régime de mission':'Régime de mission',
        'Nombre de jours (si temps partiel)':'Nombre de jours (si temps partiel)',
        'Réf.Facture/Client':'Réf.Facture/Client',
        'Réf.Facture/Expert':'Réf.Facture/Expert',
        // 'Date d\'émission':'Date d\'émission',
        // 'N°CRA':'N°CRA',
        'Date validation CRA':'Date validation CRA',
        // 'Réf.Client':'Réf.Client',
        'Réf.Expert':'Réf.Expert',
        // 'Nom de l\'expert':'Nom de l\'expert',
        // 'Intitulé de la mission':'Intitulé de la mission',
        'Statut Facture':'Statut Facture',
        // 'Date d\'échéance':'Date d\'échéance',

        'Statut paiement/Client':'Statut paiement/Client',
        'Statut paiement/Expert':'Statut paiement/Expert',
        // 'Nb de jours':'Nb de jours',
        'TJ Client HT':'TJ Client HT',
        'Total PC/Client':'Total PC/Client',
        'Total HT/Client':'Total HT/Client',
        'Total HT/Expert':'Total HT/Expert',
        'TVA Client':'TVA Client',
        'Total TTC/Client':'Total TTC/Client',
        'Total TTC/Expert':'Total TTC/Expert',
        'Marge brut':'Marge brut',
        'Marge net':'Marge net',
        'Resp.Comptabilité':'Resp.Comptabilité',
        'Planifier':'Planifier',
    },
    en:{
        'Réf.BDC' :'PO reference',
        // 'Date d\'émission' :'Date of issue',
        'Type' :'Type',
        // 'Intitulé de la mission' :'Job title',
        'Statut mission' :'Job status',
        // 'Client' :'Client',
        'Date de début BDC' :'PO start date',
        'Date début mission':'Asg.start date',
        'Date fin mission':'Asg.end date',
        // 'Date début BDC':'PO start date',
        // 'Date fin BDC':'PO end date',
        'Nb de jours':'No.of days',
        'Nb jours validés':'No.of validated days',
        'TJ TTC':'DR VAT incl.',
        'Fréq.de renouvellement':'Freq.of renewal',
        'Motif d\'interruption':'Reason for termination',

        'Date de fin BDC' :'PO end date',
        // 'Durée du BDC' :'PO duration',
        'Nombre de jours' :'Number of days',
        'Date estimée de fin de mission' :'Estimated end date',
        'Taux journalier' :'Daily rate',
        'Responsable opérationnel' :'Operational Manager',
        // 'Commercial' :'Commercial',
        // 'Motif d\'interruption' :'Reason for contract termination',
        'Télécharger le bon de commande' :'Download the purchase order',

        //Expert / CRA et Factures / Liste des CRA 22
        'N°CRA' :'Timesheet No.',
        'Réf.Client':'Client Ref.',
        'Nom du client' :'Client name',
        // 'Intitulé de la mission' :'Job title',
        'Statut du CRA' :'Timesheet Status',
        'Validé par l\'expert' :'Approved by expert',
        'Validé par le Resp.Op' :'Approved by Operational Manager',
        'Validé par ':'Approved by ',
        'Date validation/Expert' :'Validation date/Expert',
        'Date validation/Client' :'Validation date/Client',
        'Mois' :'Month',
        // 'Année' :'Year',
        // 'Nb de jours' :'No.of days',
        'Taux journalier HT' :'Daily rate  excl.VAT',
        'Total Astreintes' :'Total on-call',
        'Total HNO' :'Total NWH',
        'Total notes de frais':'Total expenses',

        //Expert / CRA et Factures / CRA 23
        'Jours facturés ce mois' :'Days billed this month',
        'Régularisation':'Gap invoicing',
        'Astreintes' :'On-calls',
        'Votre CRA a été validé avec succès!' :'Your timesheet has been successfully validated!',
        'Avez-vous des astreintes, des HNO ou des notes de frais à ajouter?' : 'Do you have any on-call payments, NWH (no working hours) or expense reports to add?',
        'Oui' :'Yes',
        'Non' :'No',
        'Prestation Complémentaire' :'Additional service',
        'Type d\'astreinte' :'On-call type',
        'Nombre d\'astreintes' :'Number of on-call',
        'Montant' :'Amount',
        'HNO' :'NWH',
        'Type du HNO' :'NWH type',
        'Nombre d\'heures' :'Number of hours',
        'Montant total de la prestation complémentaire' :'Total amount of the additional service',
        'Ajouter des détails' :'Add details',
        'Ajoutez des détails si nécessaire de détailler au client la nature et la date de chaque prestation complémentaire, et aussi ajoutez des pièces justificatives si vous en avez' :'Add details if necessary to detail to the client the nature and date of each additional service, also add supporting documents if you have any',
        'Ajouter un document' :'Add document',
        'Informations mission' :'Job information',
        'Réf. client' :'Client ref.',
        'Réf. Client' :'Client ref.',
        // 'Nom du client' :'Client Name',
        'Source' :'Source',
        'Réf. AO ou CVthèque' :'Job or CVlibrary ref.',
        // 'Intitulé de la mission' :'Job Title',
        'Nom de l\'expert' :'Expert Name',
        'Réf. Expert' :'Expert',
        'Date de début/mission' :'Start date/Job',
        'Date de fin/mission':'End date/Job',
        // 'Nombre de jours' :'Number of days',
        'Lieu de la mission' :'Assignment location',
        'Personnel en charge de la mission' :'Staff in charge of the assignment',
        'Chargé de recrutement' :'Recruitment officer',
        'Responsable achat' :'Purchasing Manager',
        // 'Responsable opérationnel' :'Operational manager',
        'Responsable de comptabilité' :'Accounting Manager',
        //Expert / CRA et Factures / Factures 24
        'Régularisations' :'Gap Invoicing',
        // 'Factures' :'Invoices',
        'Réf.Facture' :'Invoice ref.',
        // 'Date d\'émission' :'Date of issue',
        // 'Nom du client' :'Client',
        // 'N°CRA' :'Timesheet No.',
        // 'Intitulé de la mission':'Job title',
        'Statut Paiement':'Payment status',
        'Non payé':'unpaid',
        'Payé' :'Paid',
        'Période':'Period',
        'Date d\'échéance'	:'Due date',
        'Total HT' :'Total excl.VAT',
        'Total PC.HT' :'Total AS excl.VAT',
        'TVA' :'VAT',
        'Total TTC' :'Total VAT incl.',
        'Resp.Opérationnel' :'Operational manager',
        //tableau Gestion des experts 49

        'Réf.expert':'Expert Ref.',
        'CV HTH':'HTH CV',
        'CV d\'origine':'Original CV',
        // 'Titre':'Gender',
        'Intitulé du CV':'CV title',
        'Tél':'Tel',
        // 'E-mail':'Email',
        'Total Exp.':'Total Exp.',
        'Statut doc.administratifs':'Documents status',
        // 'Validé':'Approved',
        // 'A valider':'To validate',
        // 'Statut mission':'Mission status',
        'Nb de missions':'Total assignments',
        'En cours':'In progress',
        'A venir':'Coming',
        'Interrompue':'Interrupted',
        'Terminée':'Completed',
        // 'Date de disponibilité':'Availability',
        // 'Taux journalier':'Daily rate',
        // 'Ville':'City',
        // 'Pays':'Country',
        'Dernière activité':'Last activity',
        'Evaluation interne':'Internal evaluation',
        'Bloquer l\'utilisateur':'Block user',

        // 'Données profil':'Profile data',
        // 'Données CV':'CV data',
        // 'Préférences':'Preferences',
        // 'Taux de la TVA':'VAT rate',
        // 'Coordonnées bancaires':'Bank account information',
        'RIB':'Bank details',
        // 'IBAN':'IBAN',
        // 'BIC/SWIFT':'BIC/SWIFT',

        //interface_50_Gestion des clients
        // 'Réf.Client':'Client ref.',
        'Statut du compte':'Account Status',
        'Activé': 'Activated',
        'Non activé': 'Not activated',
        'Statut doc.administratif':'Doc.status',
        'AO ouverts':'Open jobs',
        // 'Nb de missions':'Total assignments',
        'TVA appliqué':'VAT applied',

        'Profil entreprise':'Company profile',
        // 'Données Générales':'General data',
        'Collaborateurs entreprise':'Company collaborators',
        // 'Données Facturation':'Billing Data',
        // 'Prestation Complémentaire':'Additional service',
        // 'Conditions de paiement':'Payment Terms',
        'Par virement':'By transfer',
        'Type de règlement':'Paiement type',
        'Délai de paiement':'Payment deadline',
        // 'Astreintes':'On-call',
        // 'Type d\'astreinte':'On-call type',
        'Astreinte standard':'Standard on-call',
        // 'Montant':'Amount',
        // 'HNO':'NWH (non-working Hours)',
        'Type de HNO':'NWH type',

        //Gestion des candidatures 53
        //CVthèque
        // 'Appels d\'offres':'Jobs',
        'CVthèque':'CvLibrary',
        // 'Gestion des RDV':'Appointment management',

        // 'Réf.AO':'Job ref.',
        'Réf.AO Client':'Job Client ref.',
        // 'Réf.Client':'Client ref.',
        'Nom du Client':'Client Name',
        'Intitulé AO':'Job title',
        'Statut AO':'Job status',
        'AO':'Job',
        // 'Nb de recrutement':'No. of recruitments',
        // 'Date de publication':'Publication date',
        // 'Nb de candidatures':'No. of applications',
        'Candidatures «à interviewer»':'Candidates \'to be interviewed\' ',
        'Candidatures «Retenues»':'\'Selected\' applications',
        'Date Début souhaitée':'Desired start date',
        'Date Fin estimée':'Estimated end date',
        // 'Localisation':'Localisation',
        // 'Durée du BDC':'PO duration',
        // 'Nb de jours':'No. of days',
        // 'Budget':'Budget',
        'Créé par':'Created by',
        // 'Resp.Opérationnel':'Operational Manager',
        'Resp.Achat':'Purchasing Manager',
        'Date Fin publication':'Publication end date',
        // 'En cours':'In progress',
        'Draft':'Draft',
        'Clôturé':'Closed',
        'Non publié':'Unpublished',
        'Statut Candidature':'Status Application',
        // 'Non lue':'Not read',
        // 'Lue':'Read',
        // 'Intéressante':'Interested',
        // 'A interviewer':'To interview',
        // 'Non retenue':'Not selected',
        // 'Retenue':'Selected',

        'Réf.Besoin':'Need ref.',
        'Intitulé du besoin':'Need Title',
        'Statut besoin': 'Need status',
        //gestion des rdv_52

        'Emplacement':'Location ',
        'Heure de début':'Start time',
        'Heure de fin':'End time',
        'Note':'Note',
        'Rejeter':'Dismiss',
        'Replanifier':'Reschedule',
        'Planifier':'Schedule',
        'Accepter':'Accept',

        //Créer une mission_51

        'Créer une mission':'Create an assignment',
        'Renouveler le BDC':'Renew the PO',
        'Modifier le BDC':'Modify the PO',

        'Informations BDC':'PO Information',
        'Date de début/BDC':'Start date/PO',
        'Date de fin/BDC':'End date/PO ',
        // 'Nombre de jours':'Number of days',
        'Fréquence de renouv.':'Renewal frequency',
        'Taux journalier/expert':'Daily rate/expert',
        'Taux journalier/client':'Daily rate/client',
        'Taux de commission':'Commission rate',
        'N°commande client':'Client order number',
        'Régime de mission':'Work schedule',
        'Nombre de jours (si temps partiel)':'Number of days (if part-time)',
        // 'Mode de travail':'Work mode',
        // 'Fréquence (télétravail)':'Frequency (teleworking)',

        // 'Factures':'Invoices',
        // 'Régularisation':'Regularization',
        'Réf.Facture/Client':'Invoice ref./Client',
        'Réf.Facture/Expert':'Invoice ref./Expert',
        // 'Date d\'émission':'Date of issue',
        // 'N°CRA':'Timesheet No.',
        'Date validation CRA':'TS validation date ',
        // 'Réf.Client':'Réf.Client',
        // 'Nom de l\'expert':'Expert\'s name',
        // 'Intitulé de la mission':'Assignment title',
        'Statut Facture':'Invoice status',
        // 'Date d\'échéance':'Due date ',

        'Statut paiement/Client':'Payment status /Client',
        'Statut paiement/Expert':'Payment Status /Expert',
        // 'Nb de jours':'No. of days',
        'TJ Client HT':'Client DR excl. VAT',
        'Total PC/Client':'Total AS/Client',
        'Total HT/Client':'Total excl.VAT/Client',
        'Total HT/Expert':'Total excl.VAT/Expert',
        'TVA Client':'Client VAT',
        'Total TTC/Client':'Total incl. VAT/Client',
        'Total TTC/Expert':'Total incl. VAT/Expert',
        'Marge brut':'Gross margin',
        'Marge net':'Net margin',
        'Resp.Comptabilité':'Accounting Manager',
        // 'Resp.Opérationnel':'Operational Manager',
        // 'Resp.Achat':'Purchasing Manager',
        // 'Chargé de recrutement':'Recruitment officer',
        'Vous souhaitez faire une régularisation pour une':'Would you like to make a regularization/regulation for a',
        'Prestation Normale':'Normal Service',
        // 'Prestation Complémentaire':'Additional service',
        'Faire une régularisation':'Make a regularization',
        'Faire une régularisation-Prestation normale':'Make a regularization-Normal Service',
        // 'Ajouter':'To add',
        'Déduire':'Deduct',
        'Montant total/expert':'Total amount/expert',
        'Montant total/client':'Total amount/Client',
        // 'Ajouter des détails':'Add details',

        'Faire une régularisation-Prestation complémentaire':'Make a regularization-Additional Service',
        'Total des astreintes':'Total on-call',
        'Total des HNO':'Total NWH',
        'Total des notes de frais':'Total expenses',
        'Notes de frais':'Expenses',
        'Montant total de la régularisation':'Total amount of the regularization',
        //Demandes à valider_57
        'Demandes à valider':'Requests to be validated',
        'Documents à valider':'Documents to validate',
        'Demandes d\'interruption':'Termination requests',
        //document administratifs
        // 'Pièce d\'identité':'Id card',
        'Kbis':'Kbis',
        // 'Attestation fiscale':'Tax receipt',
        'Assurance':'Insurance',
        'Attestation d\'assurance':'Insurance certificate',
        'Attestation URSSAF':'URSSAF certificate',
        // 'Attestation sur l\'honneur':'Sworn statement',

        'Type de document':'Document type',
        'N° du doc.':'Document no.',
        'Date de téléchargement':'Upload Date ',
        'Date du document':'Issue date',
        // 'Date d\'émission':'Issue date',
        // 'Date de validité':'Validity date',
        // 'Non validé':'Invalid',
        // 'Rejeté':'Rejected',
        // 'Motif du rejet':'Rejection reason',
        'Préciser le motif du rejet':'Specify the rejection reason',
    }
};